import React, { useState } from "react";
import logo from "../../assets/layout_assets/spotifylogo.png";
import {
  RiHome2Line,
  RiSearchLine,
  RiAddBoxFill,
  RiHeart2Fill,
  RiDownloadCloud2Line,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiCloseFill,
} from "react-icons/ri";
import { BiLibrary } from "react-icons/bi";
import { BsFillPersonFill, BsFillCaretDownFill } from "react-icons/bs";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { searchText } from "../../actions";
import { connect } from "react-redux";
function Layout({ isSearch, isLibrary, searchText, song }) {
  const navigate = useNavigate();
  //search song

  const navLinkStyle = ({ isActive }) => {
    return {
      opacity: isActive ? 1 : "",
    };
  };
  const libraryLinkStyle = ({ isActive }) => {
    return {
      opacity: isActive ? 1 : "",
    };
  };

  return (
    <div className="w-screen flex flex-col z-10">
      <div
        style={
          {
            // backgroundImage: `linear-gradient(#000000,#00000060)`,
          }
        }
        className="fixed top-0 right-0 left-60   h-16 items-center pl-2 pr-8 flex justify-between z-10"
      >
        <div className="flex items-center">
          <div
            onClick={() => navigate(-1)}
            className="p-1 rounded-full bg-[#434343] flex items-center justify-center mr-4 opacity-80 hover:opacity-100 cursor-pointer transition-all duration-200"
          >
            <RiArrowLeftSLine className="text-white text-3xl" />
          </div>
          <div
            onClick={() => navigate(+1)}
            className="p-1 rounded-full bg-[#434343] flex items-center justify-center opacity-80 hover:opacity-100 cursor-pointer transition-all duration-200"
          >
            <RiArrowRightSLine className="text-white text-3xl" />
          </div>
          {isSearch ? (
            <div className="w-96 pl-4 bg-white-400 ml-8 rounded-full flex items-center bg-white">
              <RiSearchLine className="text-black text-2xl" />
              <input
                type="text"
                value={song}
                placeholder="Artist, songs or podcast"
                onChange={(val) => searchText(val.target.value)}
                className="bg-transparent text-black flex-1 p-2 outline-none text-sm"
              />
              {song != "" && (
                <RiCloseFill
                  onClick={() => searchText("")}
                  className="text-black opacity-60 text-2xl mr-3 cursor-pointer hover:opacity-100 transition-all ease-in-out"
                />
              )}
            </div>
          ) : null}
          {isLibrary ? (
            <div className="bg-white-400 ml-8 flex items-center ">
              <NavLink
                style={libraryLinkStyle}
                to={`/library/playlist`}
                className="bg-[#ffffff3e] opacity-40 pl-4 pr-4 rounded-md p-2 mr-4 hover:opacity-60 cursor-pointer transition-all ease-linear"
              >
                <p className="text-white">Playlists</p>
              </NavLink>
              <NavLink
                style={libraryLinkStyle}
                to={`/library/podcast`}
                className="bg-[#ffffff3e] opacity-40 pl-4 pr-4 rounded-md p-2 mr-4 hover:opacity-60 cursor-pointer transition-all ease-linear"
              >
                <p className="text-white">Podcasts</p>
              </NavLink>
              <NavLink
                style={libraryLinkStyle}
                to={`/library/artist`}
                className="bg-[#ffffff3e] opacity-40 pl-4 pr-4 rounded-md p-2 mr-4 hover:opacity-60 cursor-pointer transition-all ease-linear"
              >
                <p className="text-white">Artist</p>
              </NavLink>
              <NavLink
                style={libraryLinkStyle}
                to={`/library/album`}
                className="bg-[#ffffff3e] opacity-40 pl-4 pr-4 rounded-md p-2 mr-4 hover:opacity-60 cursor-pointer transition-all ease-linear"
              >
                <p className="text-white">Albums</p>
              </NavLink>
            </div>
          ) : null}
        </div>
        <a
          target="_blank"
          href="https://jaydipvidhate.netlify.app/"
          className="flex items-center hover:bg-[#78787837] cursor-pointer p-2 rounded-full"
        >
          <BsFillPersonFill className="text-white text-3xl rounded-full bg-[#5d5d5d] p-1" />
          <h6 className="text-white ml-2 mr-2">Jaydip Vidhate</h6>
          <BsFillCaretDownFill className="text-white text-base " />
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    song: state.searchText,
  };
};

export default connect(mapStateToProps, { searchText })(Layout);
